module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-speed-dial', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "slot": "activator",
      "dark": "",
      "fab": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (_vm.$hasGranularPermission('pagamentos', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Pagamentos'
      }),
      expression: "{ html: 'Pagamentos' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesPagamentos',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("account_balance_wallet")])], 1) : _vm._e(), _vm._v(" "), (_vm.showVistoriaButton) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Vistoria'
      }),
      expression: "{ html: 'Vistoria' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.substituirVistoria()
      }
    }
  }, [_c('v-icon', [_vm._v("schedule")])], 1) : _vm._e(), _vm._v(" "), (_vm.showTarefasButton) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Tarefas'
      }),
      expression: "{ html: 'Tarefas' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'TarefasLista',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("event_available")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('info', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Info'
      }),
      expression: "{ html: 'Info' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesInfo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("info_outline")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('fotos', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Fotos de apresentação'
      }),
      expression: "{ html: 'Fotos de apresentação' }",
      arg: "left"
    }],
    staticClass: "primary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesFotos',
        params: {
          tipo: 'ilustrativa',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("photo_library")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('endereco', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Endereço'
      }),
      expression: "{ html: 'Endereço' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesEndereco',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("room")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('registro', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Registros / documentos'
      }),
      expression: "{ html: 'Registros / documentos' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesRegistro',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("description")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('area', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Área'
      }),
      expression: "{ html: 'Área' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesArea',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("filter_hdr")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('taxas', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'IPTU / impostos / taxas'
      }),
      expression: "{ html: 'IPTU / impostos / taxas' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesTaxas',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("location_city")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('valor', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Valor'
      }),
      expression: "{ html: 'Valor' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesValor',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("local_atm")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('status', 'view')) ? _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Status'
      }),
      expression: "{ html: 'Status' }",
      arg: "left"
    }],
    staticClass: "grey",
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "to": ({
        name: 'ImoveisDetalhesStatus',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("check_circle")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Baixar PDF'
      }),
      expression: "{ html: 'Baixar PDF' }",
      arg: "left"
    }],
    staticClass: "secondary",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$parent.download()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-file-pdf")])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fab),
      expression: "fab"
    }],
    staticClass: "fab-background"
  })]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "620"
    },
    model: {
      value: (_vm.dialogSubstituirVistoria),
      callback: function($$v) {
        _vm.dialogSubstituirVistoria = $$v
      },
      expression: "dialogSubstituirVistoria"
    }
  }, [_c('v-card', {
    staticClass: "botoes_com_padding_menor"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Substituir ou editar vistoria?")]), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("ATENÇÃO:")]), _vm._v(" A vistoria atual será removida caso você escolha a opção substituir.")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "primary--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogSubstituirVistoria = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat",
      "to": ({
        name: 'VistoriaEditar',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Editar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat",
      "to": ({
        name: 'VistoriaAdicionar',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Substituir")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07f65040"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/DetalhesFAB.vue
// module id = 982
// module chunks = 1